import { render, staticRenderFns } from "./ParametrizacaoAcaoPasso1.vue?vue&type=template&id=760de02c&lang=html"
import script from "./ParametrizacaoAcaoPasso1.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoAcaoPasso1.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoAcaoPasso1.vue?vue&type=style&index=0&id=760de02c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports